export default "__VITE_ASSET__2RllP6sm__"